import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPostcard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPostcard2"><Path d="M6.5 10L9.5 10M6.5 14L9.5 14M2.5 4.5H21.5V19.5H2.5V4.5ZM12.5 9.5H17.5V14.5H12.5V9.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPostcard2;
